import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class DashboardArticleCategoriesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'article_categories': [{
                    'name' : 'Bread',
                    'title' : 'Finest Bread'}
                ],
            },
            errors: [],
        };
    }

    articleCategories() {
        return this.content().article_categories;
    }
}
